import styled from 'styled-components'
import Media from 'builder/styles/media'

export const ChildrenContainer = styled.div`
  display: flex;
  width: 100%;

  ${Media.Tablet`
    display: none;
  `}
`
